<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row document-value-modal">
      <div class="form-group col-12">
        <w-vue-select v-if="!$schema.$model.id" :model="$schema.code" :values="values" @input="tryGetCurrentValues" />

        <div v-for="(date, index) in $schema.value.dates.$items" :key="'value_date_' + index" class="row">
          <w-datepicker class="pt-2 col-10" :model="date.$item.date" />

          <div class="col-2 pt-5">
            <w-button
              v-if="$schema.value.dates.$items.length > 1"
              class="btn-danger"
              icon="fas fa-trash mr-0"
              aria-label="Usuń wartość"
              @click="$schema.value.dates.$removeRow(index)"
            />
          </div>
        </div>

        <div v-for="(value, index) in $schema.value.numbers.$items" :key="'value_number_' + index" class="row">
          <w-input class="pt-2 col-10" :model="value.$item.number" />

          <div class="col-2 pt-5">
            <w-button
              v-if="$schema.value.numbers.$items.length > 1"
              class="btn-danger"
              icon="fas fa-trash mr-0"
              aria-label="Usuń wartość"
              @click="$schema.value.numbers.$removeRow(index)"
            />
          </div>
        </div>

        <yes-or-no-radio :model="$schema.value.bool" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import YesOrNoRadio from '@/components/forms/document/YesOrNoRadio.vue';
import { documentValueTranslation } from '@/filters/documentValue';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/documentValue.schema';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({ id: null, code: null, value: { date: null, dates: [], number: null, numbers: [] } });

// @vuese
// Modal dodania wartości dokumentu
// @group Document
export default {
  components: { YesOrNoRadio },
  mixins: [manageMixin('documentValue', {}, emptyData)],
  schema,
  props: {
    // Kody edytowalnych wartości dokumentów
    codes: { type: Array, required: true }
  },
  data() {
    return {
      model: {}
    };
  },
  computed: {
    values() {
      return this.codes
        .map(code => ({
          value: code,
          text: this.documentValueTranslation(code)
        }))
        .sort((a, b) => (a.text > b.text ? 1 : a.text == b.text ? 0 : -1));
    },
    title() {
      return this.id
        ? `Edycja wartości dokumentu: ${this.documentValueTranslation(this.$schema.code.$model)}`
        : 'Dodawanie wartości dokumentu';
    },
    ...mapState({
      stateData: state => {
        state.documentValue.data.value.dates?.forEach(item => (item.added = false));
        state.documentValue.data.value.numbers?.forEach(item => (item.added = false));
        return state.documentValue.data;
      }
    })
  },
  watch: {
    show(value) {
      if (value) {
        this.$schema.documentId.$setData(tryParseInt(this.$route.params.documentId));
      }
    }
  },
  mounted() {
    this.$schema.documentId.$setData(tryParseInt(this.$route.params.documentId));
  },
  methods: {
    documentValueTranslation,
    // @vuese
    // Pobierz wartości jeżeli istnieją
    tryGetCurrentValues() {
      const code = this.$schema.code.$model;
      if (code) {
        this.$schema.value.$setDefault();
        this.$store
          .dispatch('documentValue/find', { documentId: this.$schema.documentId.$model, code })
          .then(item => {
            if (item) {
              item.value.dates = item.value.dates || [];
              item.id = null;
              this.$schema.$setData(item, undefined, true);
            } else {
              this.$schema.value.$setData(emptyData().value, undefined, true);
            }
          })
          .then(() => {
            if (code.indexOf('DATE') >= 0) {
              this.$schema.value.dates.$addRow({ added: true });
            } else if (code.indexOf('NUMBER') >= 0) {
              this.$schema.value.numbers.$addRow({ added: true });
            }
          });
      }
    }
  }
};
</script>

<style>
.document-value-modal .btn.btn-danger .mr-0 {
  margin-right: 0 !important;
}
</style>
